import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {of} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {AppAuthService} from './app-auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuard {
  constructor(private authService: AppAuthService, private router: Router) {
  }

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.user$.pipe(
        map(res => {
          if (res != null) {
            return true;
          }
          return this.router.navigate(['/login', {back: state.url}]);
        }),
        catchError(() => {
          this.router.navigate(['/login', {back: state.url}]);
          return of(false);
        })
    );
  }
}
